import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const returnIcon: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  fill: 'currentColor',
  content: (
    <g id="return_icon" data-name="return icon" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <path
        id="Path_7212"
        data-name="Path 7212"
        d="M14.506,9.146a6.633,6.633,0,0,1-12.646,2.8.829.829,0,0,0-.768-.488.829.829,0,0,0-.766.492.855.855,0,0,0,.007.736,8.33,8.33,0,1,0,1.461-9.23L1.713.831A.857.857,0,1,0,0,.883L.142,5.511a.855.855,0,0,0,.294.619.855.855,0,0,0,.636.255L5.7,6.244a.857.857,0,0,0-.052-1.713l-2.614.08A6.633,6.633,0,0,1,14.506,9.146Z"
        transform="translate(-18453.793 -2942.229)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  ),
};
